export const config: any = {
    general: {
        quantity: {
            min: 1,
            max: 999
        },
        currency: {
            code: "EUR",
            symbol: "€",
            position: "after"
        },
        decimals: 2,
        roundingPrecision: 2,
        tax: {
            displayMode: "include",
            default: "standard",
            rates: {
                standard: 1.21
            },
            suffix: {
                visible: false,
                labels: {
                    include: "(incl. tax)",
                    exclude: "(excl. tax)"
                }
            }
        }
    },
    compatibility: []
}

export const theme: any = {
    general: {
        sizingBase: 16,
        animations: true, // TODO
        transition: {
            duration: "400ms",
            timingFunction: "ease-in-out" 
        },
        wrapper: {
            background: "transparent",
            padding: {
                block: 2,
                inline: 2
            }
        },
        loader: {
            width: '100%', 
            height: 192, 
            rowGap: 15,
            numOfAttributes: 2,
            type: 'variable'
        }
    }, 
    icons: {},
    components: { 
        productView: {
            height: 200 
        },
        availability: {
            color: {
                instock: "#26b11a",
                outofstock: "#b1241a",
                onbackorder: "#ff7a00"
            }
        },
        quantitySelect: { 
            maxWidth: 7.75, 
            textColor: "#333",
            background: "transparent",
            borderWidth: 0.1,
            innerBorderWidth: 0.1,
            borderRadius: 0.0,
            borderColor: "#ddd",

            buttonTextColor: "#333",
            buttonBackground: "transparent",

            hoverButtonTextColor: "#fff",
            hoverButtonBackground: "#000",

            borderColorHover: "#000"
            
        },
        addToCart: {
            background: "#fafafa",
            borderRadius: 0  
        },
        addToCartButton: {
            showIcon: false,
            iconSize: 1.5,
            textColor: "#fff",
            borderRadius: 0,
            background: "#f00000",
            hoverBackground: "#d80000"
        },
        homecreditButton: {
            background: 'transparent',
            hoverBackground: '#eee'
        },
        price: {
            animationDuration: 500,
            primaryTextColor: "#f00000",
            secondaryTextColor: "#9f9f9f" 
        },
        attributesSelect: {
            color: "#333",
            label: {
                textSize: 4
            },
            select: {}, // TODO
            swatch: {} // TODO
        }
    }
};

export const translations: any = { 
    stock: {
        instock: "In stock",
        outofstock: "Out of stock",
        onbackorder: "On backorder"
    },
    product: {
        addToCart: "Add to cart",
        pricePerUnit: "Price per unit"
    },
    unit: {
        abbr: 'pc',
        full: "piece"
    }
}